module.exports = __webpack_public_path__ + "b72eb5a8946f4537bdaa43f8fa720595.png";